import { render, staticRenderFns } from "./ElectrodeCountTwo.vue?vue&type=template&id=15d865bc&scoped=true"
import script from "./ElectrodeCountTwo.vue?vue&type=script&lang=js"
export * from "./ElectrodeCountTwo.vue?vue&type=script&lang=js"
import style0 from "./ElectrodeCountTwo.vue?vue&type=style&index=0&id=15d865bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d865bc",
  null
  
)

export default component.exports